import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Modal } from "reactstrap";
import PropTypes from "prop-types";

const ConfirmDialog = ({
  open,
  onClose,
  size,
  confirmText,
  subText,
  onConfirm,
  loading,
  renderCustomChildren,
  confirmButtonLabel,
  disabledCancel,
  buttonColor = "danger",
  icon = ["fas", "times"]
}) => {
  return (
    <Modal
      zIndex={2000}
      centered
      size={size || "md"}
      isOpen={open}
      toggle={loading ? null : onClose}>
      <div className="text-center p-5">
        <div className="avatar-icon-wrapper rounded-circle m-0">
          <div className={`d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper bg-neutral-danger text-4${buttonColor} m-0 d-130`}>
            <FontAwesomeIcon
              icon={icon}
              className="d-flex align-self-center display-3"
            />
          </div>
        </div>
        <h4 className="font-weight-bold mt-4">{confirmText}</h4>
        <p className="mb-0 font-size-lg text-muted">{subText}</p>
        <div className="pt-4">{renderCustomChildren && renderCustomChildren()}</div>
        <div className="pt-4">
          <Button
            onClick={loading ? null : onClose}
            color="neutral-secondary"
            className="btn-pill mx-1">
            <span className="btn-wrapper--label">Close</span>
          </Button>
          <Button
            disabled={disabledCancel}
            onClick={onConfirm}
            color={buttonColor}
            className="btn-pill mx-1">
            <span className="btn-wrapper--label">{confirmButtonLabel}</span>
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDialog;

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  confirmText: PropTypes.string,
  subText: PropTypes.string,
  confirmButtonLabel: PropTypes.string,
  onConfirm: PropTypes.func,
  icon: PropTypes.array
};
